import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';

import footerLogo from '../../assets/footer_logo.svg';

const Footer = () => {
    return (
        <Box sx={{ bgcolor: '#045584', color: 'white', py: { xs: 6, md: 8 } }}>
            <Container maxWidth="lg">
                {/* 1. 로고 영역 */}
                <Box sx={{ mb: 3 }}>
                    {' '}
                    {/* 로고와 아래 텍스트 사이 간격 */}
                    <img src={footerLogo} alt="GARAM MIND" />
                </Box>

                {/* 2. 텍스트 영역 (Stack/Grid 없이 Box로 처리) */}
                <Box
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 500,
                        lineHeight: 1.8,
                    }}
                >
                    <Typography variant="inherit" sx={{ display: 'block' }}>
                        (주)가람마인드 심리상담센터 | 대표 : 정현석 | 사업자번호 : 336-81-03429 |
                        통신판매번호 : 2025-대구수성구-0647
                    </Typography>

                    <Typography variant="inherit" sx={{ display: 'block' }}>
                        대구광역시 수성구 교학로 11길 46(만촌우방타운) 302동 1층 107호
                    </Typography>

                    <Typography variant="inherit" sx={{ display: 'block' }}>
                        Tel: 010-9424-3355 | Email: psych@garam-mind.com | FAX: 0504-479-3355
                    </Typography>

                    <Typography variant="inherit" sx={{ display: 'block' }}>
                        <Link
                            to="/terms-of-service"
                            style={{
                                color: 'inherit',
                                textDecoration: 'underline',
                            }}
                        >
                            이용약관
                        </Link>
                        {' | '}
                        <Link
                            to="/privacy-policy"
                            style={{
                                color: 'inherit',
                                textDecoration: 'underline',
                            }}
                        >
                            개인정보처리방침
                        </Link>
                    </Typography>

                    <Typography variant="inherit" sx={{ display: 'block', mt: 2.5 }}>
                        © 2026 GARAM MIND. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
